import { useState, useEffect } from "react";
import {
  CircularProgress,
  LinearProgress,
  makeStyles,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import Typography from "./Typography";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
  wrapper: {
    width: "100wh",
    // height: '100vh',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    padding: "0 30px",
    maxWidth: "300px",
  },
  progress: {
    marginBottom: "30px",
  },
  text: {
    textAlign: "center",
    lineHeight: "1.8",
  },
});

export default function Loader() {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const { fetching } = useSelector((state) => state.quote);
  const location = useLocation();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 730);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={classes.wrapper} style={{ height: "calc(100vh - 150px)" }}>
      {fetching && location.pathname === "/cotizacion" ? (
        <div className={classes.container}>
          <div className={classes.progress}>
            <Typography text={`${Math.round(progress)}%`} variant="h3" />
            <LinearProgress variant="determinate" value={progress} />
          </div>
          <Typography
            text="Aguarde unos momentos."
            variant="h3"
            className={classes.text}
          />
          <Typography
            text="Estamos buscando las mejores cotizaciones..."
            variant="h3"
            className={classes.text}
          />
        </div>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}
